import { useState } from 'react';
import { Restore as RestoreIcon, AttachFile as AttachFileIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { TableCell, TableRow, Tooltip, Box, Button } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import moment from 'moment';
import { dateMonthYearDateFormat, dateMonthYearFormatTime } from '../../../../constants';
import { getGlobalCookie } from '../../../../utils';
import ClaimStatusChange from './ClaimStatusChange';
import { PermissionWrapper } from '../../../../wrappers';
import LessMoreComp from '../../../../shared_elements/components/CustomLessMoreComp';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import NumericLabel from 'react-pretty-numbers';
import AuditPopover from '../../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';

function ClaimList({uploadedFileData,setUploadFileStatus, slug, uploadFileProgressData, viewFileStatus, item, onOpenAttachments, onViewFn, onEditFn,viewRevisonHistory, index, onDeleteFn, currency, getResponseBack, extraData }) {
    const userinfo = JSON.parse(getGlobalCookie('lessorAccess'))
    const [statusModal, setStatusModal] = useState({ modal: false, data: null })
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Claim Listing`, page_type: page_type, })
    }
    return (
        <>
            <TableRow key={index}>
                <TableCell className="table-actions-list insurance-actions">
                    <Box className="table-icon-container">
                        <AuditPopover item={item}>
                            <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                        </AuditPopover>
                        <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} fontSize='small' color='primary' /></Tooltip> 
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['R'] }}>
                            <Tooltip title="View"><VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onViewFn(); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /></Tooltip> 
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['U'] }}>
                            {(item?.status?.label !== "In-Review" && item?.status?.label !== "Approved") && <Tooltip title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} fontSize="small" color="primary" /></Tooltip> }
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['D'] }}>
                            {item?.status?.label !== "Approved" && <Tooltip title="Delete"><DeleteIcon sx={{ cursor: 'pointer' }} onClick={() => {onDeleteFn(item); handleItemClicked('DeleteIcon')}} fontSize='small' color='error' /></Tooltip> }
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['R'] }}>
                        {
                            item?.attachments?.length > 0 && (
                                <Tooltip title="Attached File(s)">
                                    <Box className="attachment-container">
                                            <AttachFileIcon fontSize="small" color="primary" onClick={() => {onOpenAttachments(item, 1);handleItemClicked('AttachmentsIcon')}} sx={{ cursor: "pointer" }} />
                                        <Box className="attachment-count"> ({item?.attachments?.length}) </Box>
                                    </Box>
                                </Tooltip>
                            )
                        }
                        </PermissionWrapper>
                         { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                    </Box>
                </TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onViewFn(); handleItemClicked();}}>{item?.claim_number || '--'}</TableCell>
                {/* <TableCell> {item?.amount ? currency?.code + " " + currency?.symbol + "" + item?.amount : '--'} </TableCell> */}
                <TableCell sx={{ fontSize: 13, fontWeight: 400, wordBreak: 'break-word', cursor: 'pointer' }} onClick={() => {onViewFn(); handleItemClicked();}}>
                    {item?.amount ? (
                        <NumericLabel
                            params={{
                                locales: 'en-GB',
                                currency: true,
                                precision: 2,
                                currencyIndicator: item?.currency?.code || item?.currency?.symbol?.code || '',
                                commafy: true,
                                justification: "L",
                            }}
                        >{Number(item?.amount)}</NumericLabel>
                    ) : (
                        "--"
                    )}
                </TableCell>
                <TableCell><>
                    <Button size='small'
                        className={`claim-status-${item?.status?.value}`}
                        sx={{
                            width: "110px",
                            height:"25px",
                            ...(userinfo?.user?.id === item?.user?.id && item?.status?.value === 1
                                ? {
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease-in-out',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                    },
                                }
                                : {}),
                        }}>
                        {<span style={{ display: 'flex', alignItems: 'center', gap: 2, }}> {item?.status?.label}
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance" , operationType: ['U'] }}>
                                {item?.status?.value === 1 || item?.status?.value === 4 || (userinfo?.user?.id === item?.user?.id && item?.status?.value === 2) ? 
                                <Tooltip title='Change Claim Status'>
                                        <ArrowDropDownIcon onClick={() => { setStatusModal({ modal: true, data: item }); handleItemClicked('Change Claim Status Icon') }} />
                                </Tooltip>
                             : null} 
                            </PermissionWrapper>
                        </span>} 
                        </Button>
                </></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onViewFn(); handleItemClicked();}}>{item?.user?.name || '--'}</TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onViewFn(); handleItemClicked();}}>{item?.date_of_claim_closure ? moment(item.date_of_claim_closure).format(dateMonthYearDateFormat) : '--'}</TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onViewFn(); handleItemClicked();}}><LessMoreComp name={item?.primary_contact || "--"} lessMr="primary_contact" /></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onViewFn(); handleItemClicked();}}><LessMoreComp name={item?.remarks || "--"} lessMr="remarks" /></TableCell>
            </TableRow>
            {statusModal.modal ?
                <ClaimStatusChange
                    statusModal={statusModal}
                    getResponseBack={()=>getResponseBack()}
                    onToggleModal={()=>setStatusModal({modal:false,data:null})}
                    extraData={extraData}
                    />
            :null}

        </>
    )
}

export default ClaimList